import React from 'react'

export const NavbarRoot = ({ children, active, setActive, logo, color = '#210057' }) => {
  return (
    <nav className={`navbar is-dark is-fixed-top`} style={{ backgroundColor: `${color}` }} role="navigation">
      <div className="navbar-brand">
        <img src={logo} alt="Keap Staff" style={{ width: 45, height: 45, marginBottom: 5, margin: 15 }} />

        <button
          className={`navbar-burger has-text-grey-lighter ${active ? 'is-active' : ''}`}
          onClick={(event) => {
            event.preventDefault()
            setActive(!active)
          }}
          href={null}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </button>
      </div>

      <div className={`navbar-menu ${active ? 'is-active' : ''}`}>{children}</div>
    </nav>
  )
}
